var __WEBPACK_NAMESPACE_OBJECT__ = wdg.blocks.panelsViewScript;